(() => {
  const init = () => {
    if (!location.pathname.includes('/products/mini-keepsake-figure')) return;

    const form = document.querySelector('.elune-order-form');
    const variantSelect = form?.querySelector('select[name="id"]');
    const configElement = form?.querySelector('[data-mini-type-config]');
    if (!form || !variantSelect || !configElement || form.dataset.miniConfigured) return;

    const config = JSON.parse(configElement.textContent);
    const labels = config.labels;
    const values = [...variantSelect.options].map(option => {
      const [size, finish, subjects] = option.dataset.title.split(' / ');
      return { option, size, finish, subjects, price: Number(option.dataset.price), available: option.dataset.available !== 'false' };
    });
    if (!values.length) return;
    const deliveryBox = document.querySelector('.delivery-box');
    if (deliveryBox) deliveryBox.hidden = true;
    const originalField = variantSelect.closest('.field');
    const styleGroup = form.querySelector('[data-figure-style]');
    originalField.hidden = true;

    const unique = key => [...new Set(values.map(value => value[key]))]
      .filter(value => key !== 'size' || !value.startsWith('4" Bundle Mini'));
    const sizes = unique('size');
    const finishes = unique('finish');
    const state = { size: '', finish: '', people: '1', hasPet: false, petOnly: false, together: false };
    const types = [
      { value: 'pet', name: labels.pet, people: '1', pets: 1, petOnly: true },
      { value: 'person-pet', name: labels.person_pet, people: '1', pets: 1 },
      { value: 'person', name: labels.person, people: '1', pets: 0 },
      { value: 'people-2', name: labels.people_two, people: '2', pets: 0 },
      { value: 'together', name: labels.together, people: '2', pets: 0, together: true }
    ];
    const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
    const subjectValue = (people = state.people, hasPet = state.hasPet) => {
      if (!hasPet) return people === '1' ? '1 Person or 1 Pet' : `${people} People`;
      return people === '1' ? '1 Person + 1 Additional Pet' : `${people} People + 1 Additional Pet`;
    };
    const findVariant = (size, finish, subjects) => values.find(value => value.size === size && value.finish === finish && value.subjects === subjects);
    const typeValue = () => state.petOnly ? 'pet' : state.people === '1' ? state.hasPet ? 'person-pet' : 'person' : state.together ? 'together' : `people-${state.people}`;
    const composition = () => state.petOnly ? '1 Pet' : `${state.people} ${state.people === '1' ? 'Person' : 'People'}${state.together ? ' (Together)' : ''}${state.hasPet ? ' + 1 Pet' : ''}`;

    const box = document.createElement('section');
    box.className = 'mini-configurator';
    box.innerHTML = `
      <p class="mini-configurator-note">Start with who it is for. Every figure is made from your photo.</p>
      <div class="mini-choice mini-subject-choice"><p class="mini-choice-label mini-type-heading"><span data-mini-type-heading></span> <span data-mini-type-summary></span></p><div class="mini-choice-options mini-subject-options" data-mini-people-options role="group"></div><div class="mini-pet-toggle" data-mini-pet-options hidden></div><p class="fine"><span data-mini-quote-prompt></span> <a href="https://wa.me/8618351813295" target="_blank" rel="noopener">Request a custom quote ↗</a></p></div>
      <div class="mini-choice"><p class="mini-choice-label">Size (Height includes the base)</p><div class="mini-choice-options" data-mini-size-options role="group" aria-label="Figure size"></div></div>
      <div class="mini-choice"><p class="mini-choice-label">Finish</p><div class="mini-choice-options mini-choice-options--two" data-mini-finish-options role="group" aria-label="Figure finish"></div><p class="fine" data-mini-finish-note></p></div>
      <p class="fine" data-mini-selection-status role="status" hidden></p>
      <p class="mini-price-note" role="status" aria-live="polite"><span>Your figure price</span><strong data-mini-price-note></strong></p>
      <input type="hidden" name="properties[Figure type]" data-mini-composition>`;
    box.querySelector('[data-mini-type-heading]').textContent = `${labels.heading}:`;
    box.querySelector('[data-mini-people-options]').setAttribute('aria-label', labels.heading);
    box.querySelector('[data-mini-quote-prompt]').textContent = labels.quote_prompt;
    originalField.after(box);
    if (styleGroup) box.querySelector('.mini-price-note').before(styleGroup);

    const makeButton = ({ value, name, detail = '', badge = '', selected, disabled = false, image = '', onClick }) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = image ? 'mini-option mini-subject-option' : 'mini-option';
      button.dataset.value = value;
      button.disabled = disabled;
      button.setAttribute('aria-pressed', String(selected));
      if (image) {
        const picture = document.createElement('img');
        picture.className = 'mini-subject-image';
        picture.src = image;
        picture.alt = '';
        picture.width = 500;
        picture.height = 500;
        picture.draggable = false;
        button.append(picture);
      }
      const title = document.createElement('strong');
      title.textContent = name;
      if (badge) {
        const badgeElement = document.createElement('em');
        badgeElement.textContent = badge;
        title.append(badgeElement);
      }
      button.append(title);
      if (detail) {
        const description = document.createElement('small');
        description.textContent = detail;
        button.append(description);
      }
      button.addEventListener('click', onClick);
      return button;
    };
    const render = () => {
      const sizeOptions = box.querySelector('[data-mini-size-options]');
      const finishOptions = box.querySelector('[data-mini-finish-options]');
      const peopleOptions = box.querySelector('[data-mini-people-options]');
      const petOptions = box.querySelector('[data-mini-pet-options]');
      const scrollLeft = peopleOptions.scrollLeft;
      const focused = document.activeElement;
      const focusedValue = box.contains(focused) ? focused.dataset.value : null;
      const focusedContainer = focusedValue ? focused.parentElement : null;
      sizeOptions.replaceChildren(...sizes.map(value => {
        const [name, detailWithBadge] = value.split(' — ');
        return makeButton({ value, name, detail: (detailWithBadge || '').replace(' · Most Popular', ''), badge: (detailWithBadge || '').includes('Most Popular') ? 'Most popular' : '', selected: state.size === value, disabled: !findVariant(value, state.finish, subjectValue())?.available, onClick: () => { state.size = value; sync(); } });
      }));
      finishOptions.replaceChildren(...finishes.map(value => makeButton({
        value, name: value,
        detail: value === 'Sculpted Ivory' ? 'Timeless & sculptural' : 'Vivid & personal',
        selected: state.finish === value,
        disabled: !findVariant(state.size, value, subjectValue())?.available,
        onClick: () => { state.finish = value; sync(); }
      })));
      peopleOptions.replaceChildren(...types.map(type => {
        const candidate = findVariant(state.size, state.finish, subjectValue(type.people, Boolean(type.pets && !type.petOnly)));
        return makeButton({
          value: type.value, name: type.name, image: config.images[type.value],
          selected: typeValue() === type.value,
          disabled: !candidate?.available,
          onClick: () => {
            state.people = type.people;
            state.petOnly = Boolean(type.petOnly);
            state.hasPet = Boolean(type.pets && !type.petOnly);
            state.together = Boolean(type.together);
            sync();
          }
        });
      }));
      peopleOptions.scrollLeft = scrollLeft;
      if (!form.dataset.miniConfigured && peopleOptions.scrollWidth > peopleOptions.clientWidth) {
        const selectedCard = peopleOptions.querySelector('[aria-pressed="true"]');
        if (selectedCard) {
          const cardBounds = selectedCard.getBoundingClientRect();
          const rowBounds = peopleOptions.getBoundingClientRect();
          peopleOptions.scrollLeft += cardBounds.left - rowBounds.left - (rowBounds.width - cardBounds.width) / 2;
        }
      }
      petOptions.hidden = state.petOnly || state.people !== '2';
      const withPet = findVariant(state.size, state.finish, subjectValue(state.people, true));
      const withoutPet = findVariant(state.size, state.finish, subjectValue(state.people, false));
      petOptions.replaceChildren(makeButton({
        value: 'pet', name: state.hasPet ? 'Pet added · remove' : 'Add one pet',
        detail: withPet && withoutPet ? `+ ${money(withPet.price - withoutPet.price)}` : '',
        disabled: !withPet?.available && !state.hasPet,
        selected: state.hasPet,
        onClick: () => { state.hasPet = !state.hasPet; sync(); }
      }));
      const type = types.find(value => value.value === typeValue());
      box.querySelector('[data-mini-type-summary]').textContent = type ? `${type.name}${state.people === '2' && state.hasPet ? labels.pet_suffix : ''}` : composition();
      if (focusedContainer) {
        const replacement = [...focusedContainer.querySelectorAll('[data-value]')].find(button => button.dataset.value === focusedValue);
        if (replacement && !replacement.disabled && !replacement.closest('[hidden]')) replacement.focus({ preventScroll: true });
      }
    };
    const sync = () => {
      const variant = findVariant(state.size, state.finish, subjectValue());
      const needsQuote = !['1', '2'].includes(state.people);
      const available = Boolean(variant?.available) && !needsQuote;
      variantSelect.value = variant?.option.value || '';
      box.querySelector('[data-mini-composition]').value = composition();
      box.querySelector('[data-mini-finish-note]').textContent = state.finish === 'Sculpted Ivory'
        ? 'A completed warm-ivory keepsake with a timeless sculptural finish.'
        : 'Hand-finished for hair, skin tone, clothing and key details.';
      box.querySelector('[data-mini-price-note]').textContent = variant ? variant.option.dataset.money || money(variant.price) : 'Unavailable';
      const selectionStatus = box.querySelector('[data-mini-selection-status]');
      selectionStatus.hidden = available;
      selectionStatus.textContent = needsQuote ? labels.quote_status : 'This combination is currently unavailable. Please choose another option.';
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      const wasUnavailable = form.dataset.miniUnavailable === 'true';
      form.dataset.miniUnavailable = String(!available);
      if (!available || wasUnavailable) {
        form.querySelectorAll('[data-add-button],[data-buy-now-button]').forEach(button => { button.disabled = !available; });
      }
      render();
    };

    const deepLinked = values.find(value => value.option.value === new URLSearchParams(location.search).get('variant'));
    const selected = deepLinked || values.find(value => value.option.selected) || values[0];
    state.size = selected.size;
    state.finish = selected.finish;
    state.people = selected.subjects.match(/^(\d)/)?.[1] || '1';
    state.hasPet = selected.subjects.includes('Additional Pet');
    if (!deepLinked) {
      const preferred = findVariant(sizes.find(value => value.startsWith('5" Medium')), 'Sculpted Ivory', '1 Person or 1 Pet');
      const initial = preferred?.available ? preferred : values.find(value => value.available);
      if (initial) {
        state.size = initial.size; state.finish = initial.finish;
        state.people = initial.subjects.match(/^(\d)/)?.[1] || '1';
        state.hasPet = initial.subjects.includes('Additional Pet');
      }
    }
    sync();
    form.dataset.miniConfigured = 'true';
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
